/* AWA size calculator UI v78 (CLAUDE DRAFT). Load order: core, helpers, view, io, main. */
(function () {
  function init(root) {
    var NS = window.AWACalcParts; if (!NS || !NS.h || !NS.io || !NS.view) return;
    var h = NS.h, $ = h.$, $$ = h.$$, f1 = h.f1, f2 = h.f2, el = h.el, radioVal = h.radioVal, MAX_ROOMS = h.MAX_ROOMS;
    if (!root || root.dataset.awcReady) return;
    var Core = window.AWACalcCore; if (!Core) return;
    root.dataset.awcReady = '1';
    var sid = root.dataset.sectionId;
    var cfg = {}; try { cfg = JSON.parse($(root, '[data-awc-settings]').textContent); } catch (e) {}
    var climate = Core.parseClimate(cfg.climate);
    var roomsBox = $(root, '[data-awc-rooms]'), tpl = $(root, '[data-awc-room-template]');
    var result = $(root, '[data-awc-result]'), errorBox = $(root, '[data-awc-error]');
    var modal = $(root, '[data-awc-modal]'); if (modal) document.body.appendChild(modal);
    var latest = null, snapshot = '', roomSeq = 0;
    var ctx = { root: root, result: result, modal: modal, sid: sid, cfg: cfg, latest: function () { return latest; }, openModal: function (m) { io.openModal(m); } };
    var io = NS.io(ctx), view = NS.view(ctx);
    var render = view.render, setBig = view.setBig, scale = view.scale, why = view.why, track = io.track, count = io.count, openModal = io.openModal, closeModal = io.closeModal, send = io.send;
    function c(name) { return $(modal, '[data-awc-c="' + name + '"]'); }

    function system() { return radioVal(root, 'awc-system-' + sid) || 'single'; }
    function rooms() { return $$(roomsBox, '[data-awc-room]'); }

    function addRoom(silent) {
      if (rooms().length >= MAX_ROOMS[system()]) { if (!silent) showError('You can add up to ' + MAX_ROOMS[system()] + ' rooms for this system type.'); return; }
      var node = tpl.content.firstElementChild.cloneNode(true); roomSeq++;
      $$(node, '[data-awc-group]').forEach(function (g) { $$(g, 'input').forEach(function (i) { i.name = 'awc-' + g.dataset.awcGroup + '-' + sid + '-' + roomSeq; }); });
      $(node, '[data-awc-remove]').addEventListener('click', function () { node.remove(); renumber(); changed(); });
      roomsBox.appendChild(node); renumber();
    }
    function renumber() {
      var list = rooms();
      list.forEach(function (r, i) { $(r, '[data-awc-room-title]').textContent = 'Room ' + (i + 1); $(r, '[data-awc-remove]').hidden = list.length < 2; });
      var add = $(root, '[data-awc-add]'); var max = MAX_ROOMS[system()];
      add.disabled = list.length >= max; add.textContent = list.length >= max ? 'Maximum ' + max + ' rooms' : '+ Add another room';
    }
    function updateAreas() {
      rooms().forEach(function (r) {
        var a = Number($(r, '[data-awc-length]').value) * Number($(r, '[data-awc-width]').value);
        $(r, '[data-awc-area]').textContent = a > 0 ? f1(a) + ' m²' : '— m²';
      });
    }
    function readInput() {
      return { system: system(), state: radioVal(root, 'awc-state-' + sid), climate: climate,
        ceiling: radioVal(root, 'awc-ceiling-' + sid), insulation: radioVal(root, 'awc-insulation-' + sid),
        construction: radioVal(root, 'awc-construction-' + sid), occupants: $(root, '[data-awc-occupants]').value,
        rooms: rooms().map(function (r) {
          var t = $(r, '[data-awc-type]');
          return { name: t.options[t.selectedIndex].text, type: t.value, length: $(r, '[data-awc-length]').value, width: $(r, '[data-awc-width]').value,
            windows: radioVal(r, $(r, '[data-awc-group="windows"] input').name), walls: radioVal(r, $(r, '[data-awc-group="walls"] input').name), top: $(r, '[data-awc-top]').checked };
        }) };
    }
    function fingerprint() { return JSON.stringify(readInput()); }
    function steps(done4) {
      var inp = readInput();
      var roomsOk = inp.rooms.length && inp.rooms.every(function (r) { return Number(r.length) > 0 && Number(r.width) > 0; });
      var state = [true, !!inp.state, roomsOk, !!done4]; var current = state.indexOf(false); if (current < 0) current = 3;
      $$(root, '[data-awc-step]').forEach(function (li, i) { li.classList.toggle('is-done', state[i] && i !== current); li.classList.toggle('is-current', i === current); });
    }
    function showError(msg) { errorBox.textContent = msg; errorBox.hidden = !msg; }
    function changed() {
      updateAreas(); steps(latest && fingerprint() === snapshot);
      if (latest) { var stale = fingerprint() !== snapshot; result.classList.toggle('is-stale', stale); $(result, '[data-awc-stale]').hidden = !stale; $(root, '[data-awc-mobile-go]').textContent = stale ? 'Recalculate' : 'See result'; }
    }

    function calculate() {
      showError(''); $$(root, '.is-invalid').forEach(function (x) { x.classList.remove('is-invalid'); });
      var inp = readInput();
      if (!inp.state) { showError('Please choose your state.'); $(root, '[data-awc-state-pills]').classList.add('is-invalid'); return; }
      var r = Core.compute(inp);
      if (r.error) { var bad = rooms()[r.roomIndex]; bad.classList.add('is-invalid'); showError('Please enter a length and width for Room ' + (r.roomIndex + 1) + '.'); $(bad, '[data-awc-length]').focus(); return; }
      latest = r; snapshot = fingerprint(); result.classList.remove('is-stale'); $(result, '[data-awc-stale]').hidden = true;
      render(r); steps(true); $(root, '[data-awc-mobile-go]').textContent = 'See result'; $(result, '[data-awc-email]').disabled = false;
      if (window.innerWidth < 1024) result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      track(r); count();
    }

    function reset() {
      $$(root, '[data-awc-form] input[type="radio"]').forEach(function (i) { if (i.name !== 'awc-system-' + sid) i.checked = i.defaultChecked; });
      $(root, '[data-awc-occupants]').value = 2; roomsBox.textContent = ''; addRoom(true); if (system() !== 'single') addRoom(true);
      latest = null; snapshot = ''; showError(''); result.classList.remove('is-stale', 'is-quote'); $(result, '[data-awc-stale]').hidden = true;
      setBig('—', 'kW', 'Fill in your rooms and press Calculate.'); scale(0, 0, 0); why([]);
      $(result, '[data-awc-units]').textContent = ''; $(result, '[data-awc-next]').textContent = ''; $(result, '[data-awc-heating]').hidden = true;
      $(result, '[data-awc-email]').disabled = true; $(root, '[data-awc-mobile-est]').textContent = 'Not calculated yet'; $(root, '[data-awc-mobile-go]').textContent = 'Calculate'; steps(false);
    }

    // ---- Wire up ----
    $(root, '[data-awc-add]').addEventListener('click', function () { addRoom(); changed(); });
    $(root, '[data-awc-calc]').addEventListener('click', calculate);
    $(root, '[data-awc-reset]').addEventListener('click', reset);
    $(root, '[data-awc-mobile-go]').addEventListener('click', function () { if (latest && fingerprint() === snapshot) result.scrollIntoView({ behavior: 'smooth' }); else calculate(); });
    $(root, '[data-awc-email]').addEventListener('click', function () { openModal('email'); });
    $(root, '[data-awc-onsite]').addEventListener('click', function (e) { if (latest && fingerprint() === snapshot) { e.preventDefault(); openModal('onsite'); } });
    $$(root, '[data-awc-occ]').forEach(function (b) { b.addEventListener('click', function () { var i = $(root, '[data-awc-occupants]'); i.value = Math.min(20, Math.max(1, (Number(i.value) || 2) + Number(b.dataset.awcOcc))); changed(); }); });
    $$(root, 'input[name="awc-system-' + sid + '"]').forEach(function (i) { i.addEventListener('change', reset); });
    var form = $(root, '[data-awc-form]'); form.addEventListener('input', changed); form.addEventListener('change', changed);
    $(modal, '[data-awc-send]').addEventListener('click', send);
    $(modal, '[data-awc-close]').addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
    c('phone').addEventListener('input', function () { this.value = this.value.replace(/\D/g, '').slice(0, 10); });
    c('postcode').addEventListener('input', function () { this.value = this.value.replace(/\D/g, '').slice(0, 4); });
    reset();
  }

  function boot() { document.querySelectorAll('[data-awc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();